<script setup lang="ts">
definePage({
  meta: {
    requiresAuth: true,
  },
})

const { t } = useI18n()
const route = useRoute()
const { enableSemesterSelector, setBreadcrumbs } = useBreadcrumbs()

const workspaceId = computed(() => Number((route.params as { id?: string }).id))

onMounted(() => {
  enableSemesterSelector()
  setBreadcrumbs([
    { label: t('router.pages.workspaces'), route: '/workspaces' },
    {
      label: t('router.pages.workspaces-id-events'),
      route: `/workspaces/${workspaceId.value}/events`,
    },
    { label: t('components.legacyImport.title') },
  ])
})
</script>

<template>
  <LegacyImportPanel :workspace-id="workspaceId" />
</template>
